<template>
  <div>
    <Table
      resource="Category"
      :actions="actions"
      :items="$store.getters['category/tableData']"
      :detail="$store.getters['category/detailData']"
      :fields="$store.getters['category/tableFields']"
      :pagination="$store.state.category.tablePagination"
      :keyword="$store.state.category.tableKeyword"
      :loading="$store.state.category.loadingTable"
      :filter="$store.state.category.tableFilter"
      :sort="$store.state.category.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('category/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('category/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('category/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('category/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('category/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('category/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('category/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('category/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('category/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('category/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
